import React from 'react'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'

const Wrapper = styled.div`
  margin: 34px 0 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledBar = styled.div`
  flex: 1;
  height: 1px;

  background-color: #e7ebf2;
`

const StyledText = styled.div`
  color: #b0bac9;
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 1.12px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0 20px;
`

const Divider = ({ t }) => (
  <Wrapper>
    <StyledBar />
    <StyledText>{t('contracts:dividerText')}</StyledText>
    <StyledBar />
  </Wrapper>
)

export default withNamespaces()(Divider)
